import getWindow from "./getWindow.js";
export default function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/dom-utils/getComputedStyle.js
// module id = ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
// module chunks = 1